import { Box, Link } from "@mui/material";
import youtubeSrc from "./youtube.svg";
import twitterSrc from "./twitter.svg";
import facebookSrc from "./facebook.svg";
import instagramSrc from "./instagram.svg";

interface FollowUsProps {
  borderTop: boolean;
}

export const FollowUs:React.FunctionComponent<FollowUsProps> = ({
  borderTop
}) => {
  return (
    <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: '#090808', color: '#FFFEFE'}}>
      <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'center', borderTop: borderTop ? '2px solid #FFFFFF' : 'none', padding: '24px 40px'}}>
        Follow Us on social
        {/*<Box sx={{ml: 3}}>
          <Link href='#' target='_blank' sx={{color: '#FFFEFE'}} underline='none' variant="body2" >
            <img src={youtubeSrc} alt='Youtube' />
          </Link>
        </Box>*/}
        <Box sx={{ml: 3}}>
          <Link href='https://twitter.com/TradenetRx' target='_blank' sx={{color: '#FFFEFE'}} underline='none' variant="body2" >
            <img src={twitterSrc} alt='Twitter' />
          </Link>
        </Box>
        <Box sx={{ml: 3}}>
          <Link href='https://www.facebook.com/profile.php?id=61558572505929' target='_blank' sx={{color: '#FFFEFE'}} underline='none' variant="body2" >
            <img src={facebookSrc} alt='Facebook' />
          </Link>
        </Box>
        <Box sx={{ml: 3}}>
          <Link href='https://www.instagram.com/tradenetrx/#' target='_blank' sx={{color: '#FFFEFE'}} underline='none' variant="body2" >
            <img src={instagramSrc} alt='Instagram' />
          </Link>
        </Box>
      </Box>
    </Box>
  );
}